import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/** One kind of work that waits for the signed-in staff person (#340). */
export interface WaitingItem {
  /** Stable kind key; the label is the screen's (`waitingLabels`). */
  key: string;
  count: number;
  /** The part of `count` past its time (today: withdrawal requests past the retention call). */
  flagged: number;
  oldest_at: string | null;
  /** The screen where this person acts on it; null when no screen lists it yet. */
  url: string | null;
}

export interface WaitingForMe {
  role: string;
  total: number;
  retention_call_sla_business_days: number;
  items: WaitingItem[];
}

class WaitingService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  /** Every kind the caller's role may act on, zero counts included. */
  async get(): Promise<WaitingForMe> {
    const res = await this.api.get<WaitingForMe>('/api/v1/staff/waiting');
    return res.data;
  }
}

export default new WaitingService();
